import { CheckCircleOutline } from "@mui/icons-material";
import {
  Box,
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  Stepper,
  styled,
} from "@mui/material";
import React, { useContext } from "react";
import { customColor } from "./styles/customColor";
import PropTypes from "prop-types";
import { FunctionContext } from "../context/FunctionProvider";

function WalkInStepper({ activeStep, steps }) {
  const { customBreakpoints } = useContext(FunctionContext);

  const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: "calc(-50% + 16px)",
      right: "calc(50% + 16px)",
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: customColor.secondary,
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: customColor.success,
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: customColor.tertiary_grey,
      borderTopWidth: 3,
      borderRadius: 1,
      ...theme.applyStyles("dark", {
        borderColor: theme.palette.grey[800],
      }),
    },
  }));

  const QontoStepIconRoot = styled("div")(({ theme }) => ({
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
    "& .QontoStepIcon-completedIcon": {
      color: customColor.success,
      fontSize:
        customBreakpoints.isMobile || customBreakpoints.isDeviceDown
          ? "25px"
          : "30px",
    },
    "& .QontoStepIcon-notCompletedIcon": {
      color: "grey",
      zIndex: 1,
      fontSize:
        customBreakpoints.isMobile || customBreakpoints.isDeviceDown
          ? "25px"
          : "30px",
    },
    "& .QontoStepIcon-activeIcon": {
      color: customColor.secondary,
      fontSize:
        customBreakpoints.isMobile || customBreakpoints.isDeviceDown
          ? "25px"
          : "30px",
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[700],
    }),
    variants: [
      {
        props: ({ ownerState }) => ownerState.active,
        style: {
          color: "#784af4",
        },
      },
    ],
  }));
  function QontoStepIcon(props) {
    const { active, completed, className } = props;
    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        <CheckCircleOutline
          className={
            completed
              ? "QontoStepIcon-completedIcon"
              : active
              ? "QontoStepIcon-activeIcon"
              : "QontoStepIcon-notCompletedIcon"
          }
        />{" "}
      </QontoStepIconRoot>
    );
  }

  QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
  };

  return (
    <Box width={"100%"}>
      <Stepper
        activeStep={activeStep}
        connector={<QontoConnector />}
        sx={{ width: "100%" }}
      >
        {steps.map((label) => (
          <Step  key={label}>
            <StepLabel
              slots={{ stepIcon: QontoStepIcon }}
              sx={{
                [`& .MuiStepLabel-label.Mui-active`]: {
                  color: customColor.secondary,
                },
                [`& .MuiStepLabel-label.Mui-completed`]: {
                  color: customColor.success,
                },
                // },
              }}
              //   StepIconComponent={QontoStepIcon}
            >
              <span
                style={{
                  fontFamily: "Poppins-Semibold",
                  fontSize:
                    customBreakpoints.isMobile || customBreakpoints.isDeviceDown
                      ? "13px"
                      : "20px",
                }}
              >
                {" "}
                {label}
              </span>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}

export default WalkInStepper;
